export default "__VITE_ASSET__OMDrbOsp__"